import { useEffect, useRef } from 'react';

/**
 * Hook to prevent background scroll when a modal/sheet is open
 * Only activates when isLocked is explicitly true
 */
export function useBodyScrollLock(isLocked) {
  const scrollPositionRef = useRef(0);
  const isLockedRef = useRef(false);

  useEffect(() => {
    // Only lock if explicitly true (not just truthy)
    if (isLocked !== true) {
      // If we were previously locked, restore
      if (isLockedRef.current) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPositionRef.current);
        isLockedRef.current = false;
      }
      return;
    }

    // Already locked, skip
    if (isLockedRef.current) return;

    // Save current scroll position
    scrollPositionRef.current = window.scrollY;
    isLockedRef.current = true;

    // Lock scroll
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPositionRef.current}px`;
    document.body.style.width = '100%';

    return () => {
      // Restore on unmount
      if (isLockedRef.current) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPositionRef.current);
        isLockedRef.current = false;
      }
    };
  }, [isLocked]);
}

export default useBodyScrollLock;
